<template>
  <div
    class="plus-skill-card-wrap"
    :data-skill-id="card.id"
    :class="isHovering ? 'plus-skill-card-wrap--hover' : ''"
    @mouseenter="onEnter"
    @mouseleave="onWrapLeave"
  >
    <article
      class="plus-skill-card"
      :class="isHovering ? 'plus-skill-card--expanded' : 'plus-skill-card--compact'"
    >
      <!-- 图2：默认横条 -->
      <div v-show="!isHovering" class="plus-skill-card__slot plus-skill-card__bar">
        <img
          v-if="card.image"
          :src="card.image"
          alt=""
          class="plus-skill-card__bar-thumb"
          loading="lazy"
        />
        <div
          v-else
          class="plus-skill-card__bar-thumb plus-skill-card__bar-thumb--placeholder bg-gradient-to-br"
          :class="card.thumbGradient"
        ></div>
        <div class="plus-skill-card__bar-text">
          <h3 class="plus-skill-card__bar-title">{{ card.title }}</h3>
          <p class="plus-skill-card__bar-desc">{{ card.desc }}</p>
        </div>
      </div>

      <!-- 图1：悬停上区（高度与图2一致） -->
      <div v-show="isHovering" class="plus-skill-card__slot plus-skill-card__tip" @click="onTipClick">
        <div class="plus-skill-card__try-wrap">
          <button type="button" class="plus-skill-card__try-btn" @click.stop="onTryClick">
            试一试
          </button>
        </div>
        <p class="plus-skill-card__tip-desc">
          <span>{{ card.desc || card.title }}</span>
          <i class="fas fa-arrow-up-right plus-skill-card__tip-arrow"></i>
        </p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PlusSkillCard',
  props: {
    card: { type: Object, required: true }
  },
  data() {
    return {
      isHovering: false,
      leaveTimer: null
    }
  },
  beforeDestroy() {
    this.clearLeaveTimer()
    this.$emit('skill-video-hide', this.card.id)
  },
  methods: {
    clearLeaveTimer() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer)
        this.leaveTimer = null
      }
    },
    hasVideo() {
      const url = this.card && this.card.videoUrl ? String(this.card.videoUrl).trim() : ''
      return !!url
    },
    emitVideoShow() {
      const el = this.$el
      if (!el || !this.hasVideo()) return
      const r = el.getBoundingClientRect()
      this.$emit('skill-video-show', {
        card: this.card,
        rect: {
          top: r.top,
          left: r.left,
          bottom: r.bottom,
          width: r.width
        }
      })
    },
    onEnter() {
      this.clearLeaveTimer()
      this.isHovering = true
      if (!this.hasVideo()) return
      this.emitVideoShow()
      this.$nextTick(() => this.emitVideoShow())
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(() => this.emitVideoShow())
      }
    },
    onWrapLeave() {
      this.clearLeaveTimer()
      this.leaveTimer = setTimeout(() => {
        this.isHovering = false
        this.$emit('skill-video-hide', this.card.id)
      }, 220)
    },
    onTryClick() {
      this.openLink()
    },
    onTipClick() {
      this.openLink()
    },
    openLink() {
      const url = this.card.linkUrl ? String(this.card.linkUrl).trim() : ''
      if (!url || !/^https?:\/\//i.test(url)) return
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
.plus-skill-card-wrap {
  --skill-slot-h: 68px;
  --skill-slot-w: 260px;
  position: relative;
  flex-shrink: 0;
  width: var(--skill-slot-w);
  min-width: var(--skill-slot-w);
  max-width: var(--skill-slot-w);
  height: var(--skill-slot-h);
}

.plus-skill-card-wrap--hover {
  z-index: 30;
}

.plus-skill-card {
  width: 100%;
  height: var(--skill-slot-h);
}

.plus-skill-card__slot {
  box-sizing: border-box;
  height: var(--skill-slot-h);
  min-height: var(--skill-slot-h);
  width: 100%;
}

.plus-skill-card__bar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 100%;
  padding: 10px 12px;
  border-radius: 18px;
  border: 1px solid #2c2c2c;
  background: #121212;
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.04);
}

.plus-skill-card__bar-thumb {
  height: 44px;
  width: 44px;
  flex-shrink: 0;
  border-radius: 9999px;
  object-fit: cover;
}

.plus-skill-card__bar-thumb--placeholder {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.plus-skill-card__bar-text {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.plus-skill-card__bar-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #fff;
}

.plus-skill-card__bar-desc {
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1.4;
  color: #888;
}

.plus-skill-card__tip {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 8px 12px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(38, 38, 38, 0.92);
  text-align: center;
  cursor: default;
}

.plus-skill-card__try-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
}

.plus-skill-card__try-wrap::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 0;
  height: 32px;
  width: 100px;
  transform: translate(-50%, -50%);
  border-radius: 9999px;
  background: radial-gradient(
    ellipse at center,
    rgba(255, 255, 255, 0.14) 0%,
    transparent 70%
  );
  pointer-events: none;
}

.plus-skill-card__try-btn {
  position: relative;
  z-index: 1;
  border: none;
  border-radius: 9999px;
  background: #0a0a0a;
  padding: 5px 18px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}
.plus-skill-card__try-btn:hover {
  background: #151515;
}

.plus-skill-card__tip-desc {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  font-size: 12px;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.92);
}

.plus-skill-card__tip-desc span {
  vertical-align: middle;
}

.plus-skill-card__tip-arrow {
  margin-left: 4px;
  font-size: 10px;
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.75);
}
</style>
